// extracted by mini-css-extract-plugin
export default {"multiAvatar":"styles_multiAvatar__qYVP6","avatar":"styles_avatar__+7SC8","avatarWrap":"styles_avatarWrap__RM0ZM","overlay":"styles_overlay__EduAH"};